import { render, staticRenderFns } from "./modals_yaplay.vue?vue&type=template&id=12ce46dc&"
import script from "./modals_yaplay.vue?vue&type=script&lang=js&"
export * from "./modals_yaplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports